import * as React from "react";
import { SquareButton, CompanyLogoOutlined, MuseLogo } from "@themuse/design-system";

import styles from "./sponsoredRecircWidget.module.scss";

interface TrackingEntity {
    trackingId: string;
    eventProps: object;
}

export interface TrackingProps {
    jobListingItem?: { [key: string]: TrackingEntity };
    companyProfileCTA?: TrackingEntity;
}

export interface SponsoredRecircWidgetProps {
    companyLogoUrl: string;
    companyName: string;
    companyProfileUrl: string;
    companySearchUrl: string;
    companyImageUrl: string;
    trackingProps?: TrackingProps;
}

export const SponsoredRecircWidget = (props: SponsoredRecircWidgetProps) => {
    const {
        companyLogoUrl,
        companyName,
        companyProfileUrl,
        companyImageUrl
    } = props;
    const clickTrackingProps = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify({
            sp_click_component: "button",
            sp_click_button_type: "job_search",
            sp_click_insert_type: "sponsor_company_jobs",
            sp_click_button_text: "learn more",
            sp_click_position: "right_rail",
            sp_click_target_page_position: "profile"
        })
    };

    return (
        <div className={styles.sponsoredRecircWidget}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <CompanyLogoOutlined className={styles.logoPill} altText={`${companyName} Logo`} logoUrl={companyLogoUrl} />
                    <img
                        alt={`${companyName} Profile`}
                        loading="lazy"
                        className={styles.companyImage}
                        width={300}
                        height={200}
                        src={companyImageUrl}
                    />
                </div>
                <div className={styles.mainContent}>
                    <h5 className={styles.title}>
                        Explore Jobs At
                        <span className={styles.companyName}>{companyName}</span>
                    </h5>
                </div>
                <div className={styles.footer}>
                    <SquareButton
                        className={styles.companyProfileCta}
                        color="secondary-100"
                        href={companyProfileUrl}
                    >
                        <span {...clickTrackingProps}>Learn More</span>
                    </SquareButton>
                </div>
                <div className={styles.museLogo}>
                    <MuseLogo />
                </div>
            </div>
        </div>
    );
};
